import { applyEdgeChanges } from 'reactflow';


export const updateFlowEdges = (newEdges, oldEdges) => {
  const newEdgesState = applyEdgeChanges(newEdges, oldEdges);

  return newEdgesState;
};
